import { useEffect, useState, useRef } from "react";
import { api, errMsg } from "@/lib/api";
import { useChat } from "@/context/ChatContext";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { toast } from "sonner";

export function DmRequestWatcher() {
  const { openDm, setRequestCount } = useChat();
  const [current, setCurrent] = useState(null);
  const dismissed = useRef(new Set());

  useEffect(() => {
    const poll = async () => {
      try {
        const { data } = await api.get("/notifications");
        setRequestCount(data.incoming_requests.length);
        data.accepted_requests.forEach((r) => {
          toast.success(`${r.to_username} sohbet isteğini kabul etti!`, {
            action: { label: "Sohbete git", onClick: () => openDm(r.conversation_id) },
          });
        });
        setCurrent((cur) => {
          if (cur) return cur;
          const next = data.incoming_requests.find((r) => !dismissed.current.has(r.id));
          return next || null;
        });
      } catch (e) { /* ignore */ }
    };
    poll();
    const t = setInterval(poll, 5000);
    return () => clearInterval(t);
  }, [openDm, setRequestCount]);

  const respond = async (accept) => {
    if (!current) return;
    const req = current;
    dismissed.current.add(req.id);
    setCurrent(null);
    try {
      const { data } = await api.post(`/dm/requests/${req.id}/respond`, { accept });
      if (accept && data.conversation_id) {
        toast.success(`${req.from_username} ile sohbet başladı.`);
        openDm(data.conversation_id);
      } else if (!accept) {
        toast("İstek reddedildi.");
      }
    } catch (e) {
      toast.error(errMsg(e));
    }
  };

  return (
    <AlertDialog open={!!current}>
      <AlertDialogContent className="bg-slate-950/95 backdrop-blur-xl border-slate-800 text-slate-100" data-testid="dm-request-dialog">
        <AlertDialogHeader>
          <AlertDialogTitle className="font-display">Sohbet İsteği</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-300">
            <b className="text-cyan-300">{current?.from_username}</b> sizinle sohbet etmek istiyor. Onaylıyor musunuz?
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="dm-request-reject" onClick={() => respond(false)} className="bg-slate-900 border-slate-700 text-slate-200 hover:bg-slate-800">Reddet</AlertDialogCancel>
          <AlertDialogAction data-testid="dm-request-accept" onClick={() => respond(true)} className="cx-btn-primary">Onayla</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
